import { styled } from '@mui/material/styles';
import { COLORS } from '../../../common/Styleguide/Common/colors';

export const ActionLinkContainer = styled('div')(({ theme }) => ({
  height: theme.spacing(10),
  zIndex: 1201,
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',
  position: 'fixed',
  bottom: 0,
  backgroundColor: COLORS.black[90],
  padding: `0 ${theme.spacing(3)}`,
  right: 0,
  boxSizing: 'border-box',
  borderTop: `1px solid ${COLORS.black[50]}`,
}));
